if (typeof ProductsSet !== 'function') {

  class ProductsSet extends HTMLElement {

    constructor() {
      super();

      // === Konfiguration ===
      this.minSelected = 2;

      // === State ===
      this.set = {};

      // === Init ===
      this.initCards();
      this.attachSubmitHandler();
      this.updateState();
    }

    initCards() {
      this.querySelectorAll('.product-item').forEach((card, index) => {
        const setid = index;
        card.dataset.setIndex = setid;

        const variantInput = card.querySelector('input[name="id"]');
        if (!variantInput) {
          this.set[setid] = null;
          return;
        }

        const variantId = variantInput.value;
        this.set[setid] = null;

        this.injectAddButton(card, setid, variantId);
      });
    }

    injectAddButton(card, setid, variantId) {
      const textArea = card.querySelector('.product-item__text');
      if (!textArea) return;

      // Hoppa över om knappen redan finns (t.ex. efter reset)
      if (textArea.querySelector('.set-add-toggle')) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'set-add-toggle';
      button.dataset.setIndex = setid;
      button.dataset.variantId = variantId;
      button.setAttribute('aria-pressed', 'false');

      button.innerHTML = `
        <span class="set-add-toggle__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
            <path class="set-add-toggle__icon-plus" d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path class="set-add-toggle__icon-check" d="M5 12l5 5L20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="set-add-toggle__label" data-js-label>Lägg till</span>
      `;

      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleCard(setid, variantId, button, card);
      });

      textArea.appendChild(button);
    }

    toggleCard(setid, variantId, button, card) {
      if (this.set[setid] === null) {
        this.set[setid] = variantId;
        card.classList.add('selected');
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        button.querySelector('[data-js-label]').textContent = 'Tillagd';
      } else {
        this.set[setid] = null;
        card.classList.remove('selected');
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
        button.querySelector('[data-js-label]').textContent = 'Lägg till';
      }

      this.updateState();
    }

    updateState() {
      const count = Object.values(this.set).filter(v => v !== null).length;
      const submitText = this.querySelector('[data-js-add-set-to-cart-text]');
      if (!submitText) return;

      if (count >= this.minSelected) {
        this.classList.remove('products-set--empty');
        const noun = count === 1 ? 'filt' : 'filtar';
        submitText.textContent = `Lägg till ${count} ${noun} i varukorgen`;
      } else {
        this.classList.add('products-set--empty');
        if (count === 0) {
          submitText.textContent = `Välj minst ${this.minSelected} filtar`;
        } else {
          const needed = this.minSelected - count;
          const noun = needed === 1 ? 'filt' : 'filtar';
          submitText.textContent = `Välj ${needed} ${noun} till`;
        }
      }
    }

    attachSubmitHandler() {
      const submitButton = this.querySelector('[data-js-add-set-to-cart]');
      if (!submitButton) return;

      submitButton.addEventListener('click', (e) => {
        e.preventDefault();

        const items = Object.values(this.set)
          .filter(v => v !== null)
          .map(id => ({ id: parseInt(id, 10), quantity: 1 }));

        if (items.length < this.minSelected) return;

        submitButton.classList.add('working');

        window.handleAddToCart(
          JSON.stringify({ items }),
          items.length,
          { 'Content-Type': 'application/json' },
          () => {
            submitButton.classList.remove('working');
            this.resetSet();
          }
        );
      });
    }

    resetSet() {
      Object.keys(this.set).forEach(key => {
        this.set[key] = null;
      });

      this.querySelectorAll('.product-item').forEach(card => {
        card.classList.remove('selected');
      });

      this.querySelectorAll('.set-add-toggle').forEach(btn => {
        btn.classList.remove('is-selected');
        btn.setAttribute('aria-pressed', 'false');
        const label = btn.querySelector('[data-js-label]');
        if (label) label.textContent = 'Lägg till';
      });

      this.updateState();
    }
  }

  if (typeof customElements.get('products-set') === 'undefined') {
    customElements.define('products-set', ProductsSet);
  }

}